import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconAddPhotoOutline = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-label="IconAddPhotoOutline"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M3.11 32Q1.8 32 .9 31.1T0 28.89V3.11Q0 1.8.9.9T3.11 0h15.596q.647 0 1.112.455t.464 1.1-.464 1.1q-.465.456-1.112.456H3.11V28.89H28.89V13.294q-.001-.63.454-1.082a1.49 1.49 0 0 1 1.086-.452q.633 0 1.101.453.47.452.469 1.081V28.89q0 1.31-.921 2.21-.922.9-2.19.9zM25.056 6.988h-1.96q-.63 0-1.082-.463a1.53 1.53 0 0 1-.452-1.108q0-.645.452-1.092a1.48 1.48 0 0 1 1.081-.448h1.96v-1.96q0-.63.455-1.081a1.49 1.49 0 0 1 1.086-.453q.633 0 1.101.453.47.452.47 1.081v1.96h1.917q.647 0 1.112.455t.464 1.1-.464 1.1q-.465.456-1.112.456h-1.918v1.917q0 .672-.466 1.124a1.55 1.55 0 0 1-1.118.453q-.633 0-1.08-.453a1.54 1.54 0 0 1-.446-1.124zM14.658 23.35l-3.452-4.516a.788.788 0 0 0-1.236 0l-3.621 4.73q-.34.4-.107.818t.703.417h18.067q.447 0 .671-.426t-.032-.81l-4.943-6.604q-.258-.299-.62-.277a.86.86 0 0 0-.615.32z" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconAddPhotoOutline);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
